<template>
  <section id="Course-section" class="container p-md-0">
    <header class="hero" :style="{ backgroundImage: `url('${getImageUrl(details.bgImage)}')` }"></header>
    <section class="raised-section container">
      <main class="card p-48">
        <h1 class="font56 font-weight-bold mb-4">{{details.category}}</h1>
        <p class="font24 font-weight-bold mb-4 mobile_font18">{{details.fullDescription}}</p>
        <p class="font16 mb-4">{{details.disclaimer}}</p>
        <p class="font16 font-italic mb-4" v-html="details.note">Note: {{details.note}}</p>
        <ul class="row icon-grid text-center">
          <li class="grid-icon col-lg-3 col-md-6">
            <img src="../assets/images/cpe_icons_start.svg" class="image-icons_li" alt>
            <p class="font16">
              <span class="font-weight-bold">Start</span>:
              <span class="d-md-none d-lg-block ml-1">{{details.start_date}}</span>
            </p>
            <p class="font16 d-none d-lg-none d-md-block">
              <span>{{details.start_date}}</span>
            </p>
          </li>
          <li class="grid-icon col-lg-3 col-md-6">
            <img src="../assets/images/cpe_icons_duration.svg" class="image-icons_li" alt>
            <p class="font16">
              <span class="font-weight-bold">Duration</span>:
              <span class="d-md-none d-lg-block ml-1">{{details.duration}}</span>
            </p>
            <p class="font16 d-none d-lg-none d-md-block">
              <span>{{details.duration}}</span>
            </p>
          </li>
          <li class="grid-icon col-lg-3 col-md-6">
            <img src="../assets/images/cpe_icons_location.svg" class="image-icons_li" alt>
            <p class="font16">
              <span class="font-weight-bold">Location</span>:
              <span class="d-md-none d-lg-block ml-1">{{details.delivery}}</span>
            </p>
            <p class="font16 d-none d-lg-none d-md-block">
              <span>{{details.delivery}}</span>
            </p>
          </li>
          <li class="grid-icon col-lg-3 col-md-6">
            <img src="../assets/images/cpe_icons_price.svg" class="image-icons_li" alt>
            <p class="font16">
              <span class="font-weight-bold">Certificate of completion</span>:
              <span class="d-md-none d-lg-block ml-1">{{details.certificate}}</span>
            </p>
            <p class="font16 d-none d-lg-none d-md-block">
              <span>{{details.certificate}}</span>
            </p>
          </li>
        </ul>
        <aside v-if="details.warning" class="	d-none d-lg-block bg-gray col-lg-8 shadow-sm mx-auto">
          <div class="row">
            <div class="col-lg-3 d-flex justify-content-center align-items-center">
              <span class="circle-border">
                <img
                  src="../assets/images/file-alt-solid.svg"
                  alt="File image"
                  class="image-icons"
                >
              </span>
            </div>
            <div class="col-lg-9" v-html="courseSection"></div>
          </div>
        </aside>
      </main>
    </section>
  </section>
</template>

<script>
import { request } from "http";
export default {
  data(){
    return{
      courseSection:''
    }
  },
  props: {
    details: Object
  },
  mounted(){
    if(this.details.warning){
    this.courseSection = this.details.warning.description.replace('$dataSection$','english language learning');}
  },
  methods: {
    getImageUrl(image) {
      return require(`../assets/images/${image}`);
    }
  }
};
</script>

<style>
.hero {
  background-repeat: no-repeat;
  background-size: cover;
  height: 500px;
  background-position: 40%;
}

.raised-section {
  margin-top: -6rem;
}
.icon-grid {
  list-style: none;
  padding: 0;
}
.bg-gray {
  background-color: #f1f1f1;
  padding: 24px;
}
.circle-border {
  background-color: black;
  width: 78px;
  height: 78px;
  line-height: 78px;
  border-radius: 50%;
  text-align: center;
}
@media (min-width: 768px) {
  .raised-section {
    padding: 2rem;
  }
}
@media (max-width: 768px) {
  #Course-section.container {
    padding: 0;
  }
  .hero {
  background-position: 67%;
}
  .icon-grid li{
    display: flex;
    align-items: center;
  }
  .icon-grid p{
    margin: 0;
    padding-left: 10px;
  }
}
@media (min-width: 991px) {
  .raised-section {
    padding: 3rem !important;
  }
}
.image-icons_li {
    max-width: 3rem;
}
.grid-icon{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;  
}
@media (max-width: 768px) {
  .image-icons_li {
    max-width: 2rem;
  }
}

</style>
